<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">建値（支払条件）検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="load" v-permit.SHARP_INCOTERM_SEARCH class="btn-search">{{$t('app.buttons.search')}}</v-btn>
        <v-btn to="/m0061/new" v-permit.SHARP_INCOTERM_NEW>{{$t('app.buttons.new')}}</v-btn>
        <v-btn
          :disabled="selected.length!==1"
          @click="edit"
          v-permit.SHARP_INCOTERM_EDIT.SHARP_INCOTERM_DETAIL
        >{{$t('app.buttons.edit')}}</v-btn>
        <v-btn
          :disabled="selected.length===0"
          @click="remove"
          v-permit.SHARP_INCOTERM_DELETE
        >{{$t('app.buttons.remove')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <v-text-field clearable label="建値（支払条件）CD" v-model="query.code"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <v-text-field clearable label="建値（支払条件）名称" v-model="query.name"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">建値（支払条件）</h3>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="items"
        :rows-per-page-items="[10]"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.locales.ja_JP }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    query: {
      code: '',
      name: ''
    },
    items: [],
    selected: [],
    headers: [
      { text: '建値（支払条件）CD', value: 'code', sortable: false },
      { text: '建値（支払条件）名称', value: 'name', sortable: false }
    ]
  }),
  methods: {
    load() {
      this.$storeParams()
      this.$http.get('/incoterms', { params: this.query }).then(res => {
        this.items = res.data
      })
    },
    edit() {
      this.$router.push({
        name: 'EditM0061',
        query: { id: this.selected[0].id }
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map(s => {
              return this.$http.delete(`/incoterms/${s.id}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
            this.$message('', '削除成功')
          })
        }
      )
    }
  },
  mounted() {
    this.$loadParams()
    //this.load()
  }
}
</script>
